<template>
    <div >

    
        <v-card flat outlined class="mx-auto">
            <v-card-title>
                System Profile
            </v-card-title>
            <v-card-text v-if="this.analysisLevel === 'feeder' || this.analysisLevel === 'dt'">
                <v-row  v-for="item in ReportDataNew" v-bind:key="item.text">
                    <v-col style="max-width:250px">{{item.text_1}}</v-col> <v-col style="max-width:300px">{{item.value_1}}</v-col>
                    <v-col style="max-width:250px">{{item.text_2}}</v-col> <v-col style="max-width:300px">{{item.value_2}}</v-col>          
                </v-row>
            </v-card-text>
            <v-card-text v-else>
                <v-row  v-for="item in ReportDataNew1" v-bind:key="item.text">           
                    <v-col style="max-width:250px">{{item.text_1}}</v-col> <v-col style="max-width:300px">{{item.value_1}}</v-col>
                    <v-col style="max-width:250px">{{item.text_2}}</v-col> <v-col style="max-width:300px">{{item.value_2}}</v-col>
            
                </v-row>
            </v-card-text>
        </v-card>

    </div>
</template>
<script>
import { roundUp } from '../utility/roundUp';
export default {
    name:'systemprofilereport',
    props:['systemProfileReportData','analysisLevel'],
    data(){
        return{
            
            ReportDataNew:[
                {
                    text_1 : "Name of Substation",value_1 : this.systemProfileReportData.substationName,
                    text_2 : "Interconnection Location  Solar",value_2: this.systemProfileReportData.interconnectionLocationSolar
                },
                {
                    text_1 : this.analysisLevel==='dt'? 'Name of DT' :  'Name of Feeder' , value_1: this.systemProfileReportData.feederName,
                    text_2 : "Storage Capacity (MW)",value_2 :this.systemProfileReportData.storageCapacityMW==0 ? "0.00" :roundUp(this.systemProfileReportData.storageCapacityMW,2)              
                },
                {
                    text_1 : "Feeder Type",value_1: this.systemProfileReportData.feederType,
                    text_2 : "Storage Capacity(MWh)",value_2 :this.systemProfileReportData.storageCapacityMWh==0 ? "0.00" : roundUp(this.systemProfileReportData.storageCapacityMWh,2)
                    },
                {
                    text_1 : "Feeder Voltage (KV)",value_1 :roundUp(this.systemProfileReportData.feederVoltage,2),
                    text_2 : "Interconnection Location Storage",value_2: this.systemProfileReportData.interconnectionLocationSolarStorage    
                    },
                {
                    text_1 : "Feeder Length (km)",value_1 :roundUp(this.systemProfileReportData.feederLengthKm,2),
                    text_2 : this.analysisLevel==='dt'? 'DT Peak Load (MW)': "Feeder Peak Load (MW)",value_2: roundUp(this.systemProfileReportData.feederPeakLoadMW,2)
                },
                {
                    text_1 : "Solar Capacity (MW)",value_1: this.systemProfileReportData.solarCapacityMWh==0 ? "0.00" : roundUp(this.systemProfileReportData.solarCapacityMWh,2),
                }                
            ],
            ReportDataNew1:[
                {
                    text_1 : "Name of Substation",value_1 : this.systemProfileReportData.substationName,
                    text_2 : "Interconnection Location  Solar",value_2: this.systemProfileReportData.interconnectionLocationSolar

                },
                {
                
                    text_1 : "Feeder Type",value_1: this.systemProfileReportData.feederType,
                    text_2 : "Storage Capacity(MWh)",value_2 :this.systemProfileReportData.storageCapacityMWh==0 ? "0.00" : roundUp(this.systemProfileReportData.storageCapacityMWh,2)                   
                    
                    },
                {
                    text_1 : "Feeder Voltage (KV)",value_1 :roundUp(this.systemProfileReportData.feederVoltage,2),
                    text_2 : "Interconnection Location Storage",value_2: this.systemProfileReportData.interconnectionLocationSolarStorage
                    
                    },
                {
                    text_1 : "Feeder Length (km)",value_1 :roundUp(this.systemProfileReportData.feederLengthKm,2),
                    text_2 : "Substation Peak Load (MW)",value_2: roundUp(this.systemProfileReportData.feederPeakLoadMW,2)
                
                },
                {
                    text_1 : "Solar Capacity (MW)",value_1: roundUp(this.systemProfileReportData.solarCapacityMWh,2),
                    text_2 : "Storage Capacity (MW)",value_2 :this.systemProfileReportData.storageCapacityMW==0 ? "0.00" :roundUp(this.systemProfileReportData.storageCapacityMW,2) 
                }
                
            ]
        }
    },
}
</script>
<style scoped>
.v-text-field{
      width: 200px;
}
</style>